import { API_ROOT } from '../../http_client';

export const COUNTRY_API = `${API_ROOT}/country`;

export default null;
